import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const flexibility = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
